import React, { } from "react";
import PropTypes from "prop-types";
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import LoaderUI from "../components/common/loader/index";
const PublicNewLayout = ({ children }) => {
    const history = useHistory();
    // let loggedIn = useSelector(state => state.user.loggedIn);
    // let registered = useSelector(state => state.user.registered);
    let isLoading = useSelector(state => state.general.loading);
    // if (registered) {
    //     history.push('/dashboard')
    //     return null;
    // }
    // if (loggedIn) {
    //     history.push('/dashboard');
    //     return null;
    // }
   
    return (
        <>
            <div className="signup-wrappers d-flex flex-fill overflow-auto">
                <div className="col-blc left-col d-flex">
                    <div className="inner d-flex align-items-end justify-content-center flex-fill position-relative">
                        {/* <img className="img-fluid" src={require('../assets/img/login/character.svg')} alt="Login-Character" /> */}
                    </div>
                </div>
                <div className="col-blc right-col d-flex overflow-auto">
                {/* {isLoading && <LoaderUI
								loader={isLoading}
								overlay={true}
								overlayRadius='rounded-0'
								size=""
							/>} */}
                    {children}
                </div>
            </div>
        </>
    )
};

PublicNewLayout.propTypes = {
    /**
     * Whether to display the navbar, or not.
     */
    noNavbar: PropTypes.bool,
    /**
     * Whether to display the footer, or not.
     */
    noFooter: PropTypes.bool
};

PublicNewLayout.defaultProps = {
    noNavbar: false,
    noFooter: false
};

export default PublicNewLayout;
